// Dev-only logger — silenced in production to avoid leaking debug info / perf cost.
const isProd = process.env.NODE_ENV === "production";

export const logger = {
  log: (...args) => {
    if (!isProd) console.log(...args);
  },
  warn: (...args) => {
    if (!isProd) console.warn(...args);
  },
  error: (...args) => {
    if (!isProd) console.error(...args);
  },
};
